import { Layout } from '@components/commons';
import { UserTypes, useUser } from '@contexts/Shared';
import { useRouter } from 'next/router';
import React from 'react';

const withAuth = (
  WrappedComponent: React.ElementType,
  requiredRole?: UserTypes
) => {
  const defaultLoginUrl = '/ingreso';
  const referrer =
    typeof window !== 'undefined' ? window.location.href : undefined;
  // eslint-disable-next-line react/display-name
  return (props: any) => {
    const { asPath } = useRouter();
    const { user } = useUser({
      requiredRole,
      redirectTo: defaultLoginUrl,
      referrer: asPath || referrer,
    });

    if (user && user.status === 'IS_LOGGED_IN') {
      return <WrappedComponent {...props} />;
    }

    return <Layout>Cargando...</Layout>;
  };
};

export { withAuth };
